import React from 'react';

const ImageTextSection = ({ section }) => {
  const sectionData = section.section_data || {};
  const layout = sectionData.layout || 'image-left';
  const imageWidth = sectionData.image_width || '50%';
  const alignment = sectionData.alignment || 'left';

  const isVertical = layout === 'image-top' || layout === 'image-bottom';
  const imageFirst = layout === 'image-left' || layout === 'image-top';

  return (
    <section
      className="image-text-section"
      style={{
        backgroundColor: section.background_color || '#ffffff',
        color: section.text_color || '#000000',
        padding: '60px 20px'
      }}
    >
      <div className="container">
        <div
          style={{
            display: 'flex',
            flexDirection: isVertical ? 'column' : 'row',
            gap: '40px',
            alignItems: 'center'
          }}
        >
          {imageFirst && section.image && (
            <div style={{ width: isVertical ? '100%' : imageWidth }}>
              <img
                src={section.image}
                alt={section.title || 'Section image'}
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  objectFit: 'cover'
                }}
              />
            </div>
          )}

          <div
            style={{
              flex: isVertical ? 'none' : '1',
              width: isVertical ? '100%' : 'auto',
              textAlign: alignment
            }}
          >
            {section.title && (
              <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem', fontWeight: '600' }}>
                {section.title}
              </h2>
            )}
            {section.subtitle && (
              <h3 style={{ fontSize: '1.5rem', marginBottom: '1.5rem', opacity: 0.8 }}>
                {section.subtitle}
              </h3>
            )}
            {section.content && (
              <div
                style={{ fontSize: '1.1rem', lineHeight: '1.8' }}
                dangerouslySetInnerHTML={{ __html: section.content }}
              />
            )}
          </div>

          {!imageFirst && section.image && (
            <div style={{ width: isVertical ? '100%' : imageWidth }}>
              <img
                src={section.image}
                alt={section.title || 'Section image'}
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  objectFit: 'cover'
                }}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ImageTextSection;
